import React from 'react';
import { ArrowRight, MapPin, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { contactInfo } from '../mockData';

const HeroSection = ({ translations }) => {
  const scrollToMenu = () => {
    const element = document.getElementById('menu');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handleGetDirections = () => {
    window.open(contactInfo.mapUrl, '_blank');
  };

  const handleCallNow = () => {
    window.open('tel:+903124463246', '_self');
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-cream-50 via-white to-cream-100">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-10 w-72 h-72 bg-brown-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-cream-300/30 rounded-full blur-3xl"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <div className="space-y-8">
            <h1 className="text-5xl lg:text-6xl font-bold text-brown-900 leading-tight">
              {translations.heroTitle}
            </h1>

            <p className="text-xl text-brown-700 leading-relaxed">
              {translations.heroSubtitle}
            </p>

            <div className="flex flex-wrap gap-4">
              <Button
                onClick={scrollToMenu}
                size="lg"
                className="bg-brown-700 hover:bg-brown-800 text-white px-8 py-6 text-lg font-semibold transition-all hover:scale-105 shadow-lg"
              >
                {translations.viewMenu}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
              <Button
                onClick={handleGetDirections}
                size="lg"
                variant="outline"
                className="border-2 border-brown-700 text-brown-700 hover:bg-brown-50 px-8 py-6 text-lg font-semibold transition-all hover:scale-105"
              >
                <MapPin className="mr-2 h-5 w-5" />
                {translations.getDirections}
              </Button>
              <Button
                onClick={handleCallNow}
                size="lg"
                variant="outline"
                className="border-2 border-brown-700 text-brown-700 hover:bg-brown-50 px-8 py-6 text-lg font-semibold transition-all hover:scale-105"
              >
                <Phone className="mr-2 h-5 w-5" />
                {translations.callNow}
              </Button>
            </div>
          </div>

          {/* Right content - Featured images */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105">
                  <img
                    src="https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/3zwonip1_WhatsApp%20Image%202025-12-30%20at%2012.56.50%20%283%29.jpeg"
                    alt="Dere Pastanesi ürünleri"
                    className="w-full h-64 object-cover"
                  />
                </div>
                <div className="overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105">
                  <img
                    src="https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/n9sdm3s4_WhatsApp%20Image%202025-12-30%20at%2012.56.50%20%282%29.jpeg"
                    alt="Taze pastalar"
                    className="w-full h-48 object-cover"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105">
                  <img
                    src="https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/xcqsamqz_WhatsApp%20Image%202025-12-30%20at%2012.56.50%20%281%29.jpeg"
                    alt="Özel pastalar"
                    className="w-full h-48 object-cover"
                  />
                </div>
                <div className="overflow-hidden rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105">
                  <img
                    src="https://customer-assets.emergentagent.com/job_9aeb426e-28fd-44eb-97f4-b51fb46abefb/artifacts/g1uzpday_WhatsApp%20Image%202025-12-30%20at%2012.56.48%20%281%29.jpeg"
                    alt="Lezzetli tatlılar"
                    className="w-full h-64 object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;